"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import AccessibleIcon from "@travel/shared/assets/icons/amenities/icon-accessible.svg";
import CheckIcon from "@travel/shared/assets/icons/icon-check.svg";
import CasinoIcon from "@travel/shared/assets/icons/amenities/icon-casino.svg";
import FridgeIcon from "@travel/shared/assets/icons/amenities/icon-fridge.svg";
import FitnessIcon from "@travel/shared/assets/icons/amenities/icon-fitness.svg";
import BreifcaseIcon from "@travel/shared/assets/icons/amenities/icon-briefcase.svg";
import BusIcon from "@travel/shared/assets/icons/amenities/icon-bus.svg";
import MicrowaveIcon from "@travel/shared/assets/icons/amenities/icon-microwave.svg";
import PawIcon from "@travel/shared/assets/icons/amenities/icon-paw.svg";
import SwimIcon from "@travel/shared/assets/icons/amenities/icon-swim.svg";
import NoSmokingIcon from "@travel/shared/assets/icons/amenities/icon-no-smoking.svg";
import ParkingIcon from "@travel/shared/assets/icons/amenities/icon-parking.svg";
import UtensilsIcon from "@travel/shared/assets/icons/amenities/icon-utensils.svg";
import WifiIcon from "@travel/shared/assets/icons/amenities/icon-wifi.svg";
import styles from "./hotel-amenity-icon.module.css";
import { Badge } from "@travel/components/ui/badge";
var AmenityIcons = {
    3: CasinoIcon,
    5: UtensilsIcon,
    818: UtensilsIcon,
    14: UtensilsIcon,
    7: WifiIcon,
    6: WifiIcon,
    1556: WifiIcon,
    2: BreifcaseIcon,
    1: BusIcon,
    4: BusIcon,
    10: ParkingIcon,
    13: PawIcon,
    15: SwimIcon,
    59: MicrowaveIcon,
    8851: AccessibleIcon,
    5731: FitnessIcon,
    162: AccessibleIcon,
    161: AccessibleIcon,
    223: AccessibleIcon,
    1530: NoSmokingIcon,
    "FREE WIFI": WifiIcon,
    "FREE BREAKFAST": UtensilsIcon,
    67: FridgeIcon,
    FRIDGE: FridgeIcon,
    MICROWAVE: MicrowaveIcon,
};
var TOP_AMENITIES = {
    4: "Free Airport Shuttle",
    6: "Free Wifi",
    7: "Free Wifi",
    5: "Free Breakfast",
    10: "Free Parking",
    13: "Pets Allowed",
    15: "Swimming Pool",
    3: "Casino",
    2: "Business Center",
};
export function HotelAmenityIcon(_a) {
    var className = _a.className, type = _a.type, rest = __rest(_a, ["className", "type"]);
    var AmenityIcon = type
        ? AmenityIcons[type] || CheckIcon
        : CheckIcon;
    return (_jsx(AmenityIcon, __assign({}, rest, { className: classNames("icon", className), "data-travel-amenity-id": type })));
}
export function HotelAmenityIconList(_a) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? "16px" : _b, width = _a.width, height = _a.height, _c = _a.amenities, amenities = _c === void 0 ? [] : _c, _d = _a.focusedAmenities, focusedAmenities = _d === void 0 ? [] : _d, topOnly = _a.topOnly, props = __rest(_a, ["className", "size", "width", "height", "amenities", "focusedAmenities", "topOnly"]);
    return (_jsx("ul", { className: classNames(styles["amenities"], className), children: amenities === null || amenities === void 0 ? void 0 : amenities.map(function (item) {
            var _a = typeof item === "object" ? item : { id: item, name: "" }, id = _a.id, name = _a.name;
            name = name || TOP_AMENITIES[id] || String(id).toLowerCase();
            var listItem = (_jsx("li", { children: _jsxs(Badge, __assign({}, props, { children: [_jsx(HotelAmenityIcon, { className: styles["icon"], type: id, width: width ? width : size, height: height ? height : size }), _jsx("span", { className: styles["content"], children: name })] })) }, id));
            return topOnly ? (!!TOP_AMENITIES[id] ? listItem : null) : listItem;
        }) }));
}
